import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import _JSXStyle from "styled-jsx/style";
import PartCard from '@@client/parts/PartCard';
import PartCardListHeading from '@@client/parts/PartCardListHeading';
export default function PartCardList(_ref) {
  var parts = _ref.parts,
      heading = _ref.heading,
      _ref$headingBg = _ref.headingBg,
      headingBg = _ref$headingBg === void 0 ? 'blue' : _ref$headingBg;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(PartCardListHeading, {
      heading: heading,
      bg: headingBg
    }), /*#__PURE__*/_jsx("div", {
      className: "jsx-3084972533" + " " + 'parts',
      children: parts.map(function (x) {
        return /*#__PURE__*/_jsx(PartCard, {
          partInfo: x
        }, x.inventoryId);
      })
    }), /*#__PURE__*/_jsx(_JSXStyle, {
      id: "3084972533",
      children: [".parts.jsx-3084972533{display:grid;grid-column-gap:10px;margin-top:28px;}", "@media(max-width:575px){.parts.jsx-3084972533{margin-top:10px;}}", "@media(max-width:575px){.parts.jsx-3084972533{grid-template-columns:repeat(2,1fr);}.parts.jsx-3084972533>*:nth-child(n + 3){display:none;}}", "@media(min-width:576px) and (max-width:767px){.parts.jsx-3084972533{grid-template-columns:repeat(3,1fr);}.parts.jsx-3084972533>*:nth-child(n + 4){display:none;}}", "@media(min-width:768px) and (max-width:991px){.parts.jsx-3084972533{grid-template-columns:repeat(4,1fr);}.parts.jsx-3084972533>*:nth-child(n + 5){display:none;}}", "@media(min-width:992px) and (max-width:1199px){.parts.jsx-3084972533{grid-template-columns:repeat(5,1fr);}.parts.jsx-3084972533>*:nth-child(n + 6){display:none;}}", "@media(min-width:1200px){.parts.jsx-3084972533{grid-template-columns:repeat(6,1fr);}.parts.jsx-3084972533>*:nth-child(n + 7){display:none;}}"]
    })]
  });
}